import { css } from 'styled-components'

export default css`
  .modal-header .close, .modal-header svg {
    cursor: pointer;
    position: absolute;
    right: -2.5rem;
    top: 0.7rem;
    font-size: 2rem;
    color: ${({ theme }) => theme.palette.grayscale[8]};
    opacity: 1;
    
    :active, :focus {
      outline: none;
    }
    :hover {
      color: ${({ theme }) => theme.palette.grayscale[6]};
    }
  }

  .modal-header .close {
    font-size: 2.5rem;
  }
  
  .modal-content {
    border: none;
  }

  .nspaid {
    &-edit {
      width: 91%;
      margin-left: 50px;
    }

    &-view {
      margin-left: 60px;
      width: 90%;
      margin-top: 10px;
    }

    &-label {
      position: absolute;
      top: 10px;
      margin-left: 6px;
      left: 0px;
    }
  }
  
  #__react-alert__ {
    > div {
      z-index: 1200 !important;
    }
  }
`
